import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
// Style
import "./PDFComp.scss";

// Components
import PageHero from "../../containers/PageHero/PageHero";

// PDFs
import alonfabioCV from "../../static/pdf/eng/alonfabioCV.pdf"; // English
import alonfabioCV_heb from "../../static/pdf/heb/alonfabioCV_heb.pdf"; // Hebrew

function PDFComp() {
  const { lang } = useParams();

  // Select PDF based on URL param
  const pdfMap: Record<string, string> = {
    eng: alonfabioCV, // Default to English CV
    heb: alonfabioCV_heb, // Hebrew CV
  };
  const selectedPDF = pdfMap[lang || "CV"] || alonfabioCV;
  console.log("Selected PDF:", selectedPDF);
  // Function to download the PDF
  const downloadPDF = async () => {
    try {
      const fileUrl = selectedPDF;
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Alon Fabio CV.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };
  useEffect(() => {
    downloadPDF();
  }, []);

  return (
    <section className="PDF_section ">
      <PageHero>
        <h1 className="PDF_h1">Here's your PDF</h1>
      </PageHero>

      <div className="pdf_a_container flexCenter ">
        <p onClick={() => downloadPDF()} rel="noreferrer">
          Download my CV<span>.PDF</span>{" "}
          <i className="fa-solid fa-file-arrow-down"></i>
        </p>
      </div>

      <div className="PDF_object_container">
        <object
          className="PDF_object"
          data={selectedPDF}
          type="application/pdf"
        >
          <embed src={selectedPDF} type="application/pdf"></embed>
          <p>This browser does not support PDFs.</p>
        </object>
      </div>
    </section>
  );
}

export default PDFComp;
